
import { defineComponent, ref, onMounted } from 'vue';
import Character from '@/components/Character.vue';

export default defineComponent({
  components: {
    Character,
  },

  setup() {
    const randomCharacter = ref({});

    const getRandom = async () => {
      var randomId = Math.floor(Math.random() * 671);

      const res = await fetch(
        `https://rickandmortyapi.com/api/character/${randomId}`
      );

      const data = await res.json();
      randomCharacter.value = data;
      console.log(randomCharacter);
    };

    onMounted(getRandom);
    return {
      randomCharacter,
      getRandom,
    };
  },
});
